var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGolf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.61 176.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #aba8a4;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.27,78.78l15.7-48.86-3.48-1.01-5.32,15.92-14.28-4.69,4.85-14.15c.04-.59-3.31-1.58-3.46-1.47l-14.15,40.46c-3.58,6.46-10.45,2.4-15.76.95-15.29-4.18-31.09-7.29-47.01-7.59-15.35-.29-27.68,1.34-28.79,19.44-.02.33.01.67,0,1l.57,5.29c1.39,9.62,8.53,24.35,17.58,28.8,8.45,4.16,23.29,3.54,32.59,2.81,6.47-.51,12.9-1.62,19.33-2.39,1.61,4.63,4.09,8.71,7.42,12.29l.17,10.31,11.74,4.97.11,11.23h3.74l-.12-13.72-11.85-5.11v-5.36h33.91v5.36l-11.85,5.11-.12,13.72h3.74l.03-11.06,11.82-5.13.23-10.5c13.76-13.66,10.2-38.15-7.34-46.62ZM93.89,109.45c-5.32.91-10.71,1.75-16.09,2.25-9.15.85-24.58,1.84-32.95-1.95-11.9-5.39-22.97-34.38-11.68-43.93,6.22-5.26,24.76-3.85,32.66-2.98,10.66,1.18,21.95,3.54,32.29,6.36,7.55,2.06,15.68,6.7,21.15-2.04l8.27-23.52,14.71,4.74-9.23,28.67c-7.36-2.38-14.71-2.35-21.86.71-12.21,5.21-19.65,18.52-17.28,31.7ZM139.34,124.11h-33.06c-17.49-14.66-8.09-43.39,14.73-45,24.56-1.74,36.97,29.24,18.32,45Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.05,
    y: 83.52,
    width: 43.63,
    height: 3.74
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.04,
    y: 93.74,
    width: 26.43,
    height: 3.74
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.05,
    y: 73.29,
    width: 20.94,
    height: 3.74
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.69,
    y: 73.29,
    width: 6.73,
    height: 3.74
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.73,
    y: 73.29,
    width: 3.74,
    height: 3.74
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.21,
    y: 73.29,
    width: 3.74,
    height: 3.74
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.42,
    y: 83.52,
    width: 3.74,
    height: 3.74
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.21,
    y: 93.74,
    width: 3.74,
    height: 3.74
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.68,
    y: 93.74,
    width: 3.74,
    height: 3.74
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.08,
    y: 85.26,
    width: 3.74,
    height: 3.74
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.8,
    y: 85.26,
    width: 3.74,
    height: 3.74
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.6,
    y: 94.99,
    width: 3.74,
    height: 3.74
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.32,
    y: 94.99,
    width: 3.74,
    height: 3.74
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.03,
    y: 94.99,
    width: 3.74,
    height: 3.74
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.51,
    y: 104.71,
    width: 3.74,
    height: 3.74
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.6,
    y: 114.69,
    width: 3.74,
    height: 3.74
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.32,
    y: 114.69,
    width: 3.74,
    height: 3.74
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.03,
    y: 114.69,
    width: 3.74,
    height: 3.74
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.11,108.45h-3.74v-3.74l3.51.11c.51.35.11,2.89.23,3.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.82,108.45h-3.74v-3.74l3.5.11c.51.35.11,2.89.23,3.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.54,108.45h-3.74v-3.74l3.51.11c.51.35.11,2.89.23,3.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/Golf.ef0d05e0e9ad23e3bde423a862b76d36.svg";
export { ForwardRef as ReactComponent };